/**
 * Created by Ning Jiang on 3/20/2019.
 */

import {ReelController} from "@nolimitcity/slot-game/bin/core/reel/reel/ReelController";
import {StateReelSymbol} from "@nolimitcity/slot-game/bin/core/reelsymbol/StateReelSymbol";
import {SpinReelController} from "@nolimitcity/slot-game/bin/game/reel/spinreel/SpinReelController";

export class TombstoneSideReelController extends SpinReelController {

    constructor(reelId:number) {
        super(reelId);
    }

    protected createNextSymbol(previousSymbol?:StateReelSymbol, init?:boolean):StateReelSymbol {
        const newSymbol:StateReelSymbol = super.createNextSymbol(previousSymbol, init);
        if(!init) {
            if(newSymbol.symName.indexOf("B") === -1) {
                if(this._reelPartAnimator.symbolsToAnimate[0].symName.indexOf("B") > -1) {
                    this._reelPartAnimator.symbolsToAnimate[0].parent.addChild(this._reelPartAnimator.symbolsToAnimate[0]);
                }
            }
        }

        return newSymbol;
    }
}